
export const ROUTES = {
  HOME: "/",
  ALLPRODUCTS: "/allproducts",
  ADDEDITPRODUCT: "/addEditProduct",
  VIEWPRODUCT: "/viewproduct",
  DESERVES: "/deserves",
  USERPRODUCTS: "/userproducts",
  PROFILE: "/profile",
};

export const METHODTYPE = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE"
};

export const STORAGEITEMS =
{
  USERTYPE: "USERTYPE",
}

export const USERTYPE = {
  USER: "USER",
  COMPANY: "COMPANY"
};

export const LANGUAGES = [
  {
    key: 'en',
    icon: 'flag-icon-us',
    label: 'header.language.english'
  },
  /* {
      key: 'tr',
      icon: 'flag-icon-tr',
      label: 'header.language.turkish'
  }, */
  {
    key: 'de',
    icon: 'flag-icon-de',
    label: 'header.language.german'
  }
  /* {
      key: 'fr',
      icon: 'flag-icon-fr',
      label: 'header.language.french'
  },
  {
      key: 'es',
      icon: 'flag-icon-es',
      label: 'header.language.spanish'
  } */
];

export const LANGUAGECODE = {
  ENGLISH: 'en',
  GERMAN: 'de'
}

export const DATAGRIDLOCALIZATION =
{
  GERMAN: {
    body: {
      emptyDataSourceMessage: 'Keine Einträge',
      addTooltip: 'Hinzufügen',
      deleteTooltip: 'Löschen',
      editTooltip: 'Bearbeiten',
      filterRow: {
        filterTooltip: 'Filter'
      },
      editRow: {
        deleteText: 'Diese Zeile wirklich löschen?',
        saveTooltip: 'Speichern',
        cancelTooltip: 'Abbrechen'
      }
    },
    grouping: {
      placeholder: 'Spalten ziehen ...',
      groupedBy: 'Gruppiert nach:'
    },
    header: {
      actions: 'Aktionen'
    },
    pagination: {
      labelDisplayedRows: '{from}-{to} von {count}',
      labelRowsSelect: 'Zeilen',
      labelRowsPerPage: 'Zeilen pro Seite:',
      firstAriaLabel: 'Erste Seite',
      firstTooltip: 'Erste Seite',
      previousAriaLabel: 'Vorherige Seite',
      previousTooltip: 'Vorherige Seite',
      nextAriaLabel: 'Nächste Seite',
      nextTooltip: 'Nächste Seite',
      lastAriaLabel: 'Letzte Seite',
      lastTooltip: 'Letzte Seite'
    },
    toolbar: {
      addRemoveColumns: 'Spalten hinzufügen oder löschen',
      nRowsSelected: '{0} Zeile(n) ausgewählt',
      showColumnsTitle: 'Zeige Spalten',
      showColumnsAriaLabel: 'Zeige Spalten',
      exportTitle: 'Export',
      exportAriaLabel: 'Export',
      exportName: 'Export als CSV',
      searchTooltip: 'Suche',
      searchPlaceholder: 'Suche'
    }
  }
}

export const DESERVE_STATUS = {
  AVAILABLE: 0, //Not yet shared -0
  OPEN: 1, // Shared -1
  DESERVED: 2, // Got Likes and asked for Approval -2
  REMOVED: 3, // Removed from open state -3
  REJECTED_BY_ADMIN: 4, // Approval is rejected -4
  REJECTED_BY_COMPANY: 5, //Approval rejected by company after seeing postUrl -5
  ONHOLD: 6, // Approval is on-hold -6
  ACCEPTED_BY_ADMIN: 7, // Approval is accepted -7
  ACCEPTED_BY_COMPANY: 8, // Approval is accepted -8
  CLOSED: 9, // Approval is accepted and user received gift -9
  EXPIRED: 10, // Time span expired in OPEN state -10
}
export const DESERVE_BLOCKED_STATUS = {
  OPEN: 1,
  DESERVED: 2,
  ONHOLD: 6,
  ACCEPTED_BY_ADMIN: 7,
  ACCEPTED_BY_COMPANY: 8,
  CLOSED: 9,
};

export const DESERVE_STATUS_STRING_VALUE = {
  AVAILABLE: "Verfügbar", //Not yet shared -0
  OPEN: "Offen", // Shared -1
  DESERVED: "deserved", // Got Likes and asked for Approval -2
  REMOVED: "Entfernt", // Removed from open state -3
  REJECTED_BY_ADMIN: "Abgelehnt vom Admin", // Approval is rejected -4
  REJECTED_BY_COMPANY: "Abgelehnt vom Unternehmen", //Approval rejected by company after seeing postUrl -5
  ONHOLD: "Wartend", // Approval is on-hold -6
  ACCEPTED_BY_ADMIN: "Akzeptiert vom Admin", // Approval is accepted -7
  ACCEPTED_BY_COMPANY: "Akzeptiert vom Unternehmen", // Approval is accepted -8
  CLOSED: "Abgeschlossen", // Approval is accepted and user received gift -9
  EXPIRED: "Abgelaufen", // Time span expired in OPEN state -10
}

export const DESERVER_STATUS_GROUPS = {
  OPEN: [1],
  DESERVED: [2, 7],
  REJECTED: [4, 5],
  ACCEPTED: [8],
  CLOSED: [9],
  EXPIRED: [10]
};

export const APPROVED_STATUS = {
  PENDING: 0,
  APPROVED: 1,
  REJECTED: -1,
  APPROVED_IN_PAST: 2,
};

// Step 2: Map constants to their display strings
export const APPROVED_STATUS_LABELS = {
  [APPROVED_STATUS.PENDING]: "Ausstehend",
  [APPROVED_STATUS.APPROVED]: "Genehmigt",
  [APPROVED_STATUS.REJECTED]: "Abgelehnt",
  [APPROVED_STATUS.APPROVED_IN_PAST]: "Approved in past",
};